import React from "react";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 20px;
`;

export const ChoiceButton = styled.div`
    width: 100%;
    padding: 20px;
    font-size: 1.5rem;
    color: ${({ theme }) => theme.colors.blue.toString()};
    text-align: center;
    cursor: pointer;
    border: 2px solid ${({ theme }) => theme.colors.darkGrey.toString()};
    border-radius: 4px;

    &:hover {
        cursor: pointer;
        filter: brightness(85%);
    }
`;

const SubText = styled.div`
    font-size: 1rem;
`;

const ChoiceButtons = ({
    choices,
    activeId,
    onChoiceChange,
    hasSubtitle = true,
}) => {
    const theme = useTheme();

    const isActive = css`
        color: white;
        background-color: ${theme.colors.red.toString()};
        border-color: ${theme.colors.red.toString()};
    `;

    return (
        <Container>
            {choices.map((choice, index) => {
                return (
                    <ChoiceButton
                        css={css`
                            ${activeId === choice.id ? isActive : ""}
                        `}
                        key={`c-${index}`}
                        onClick={() => onChoiceChange(choice.id)}
                    >
                        <div>{choice.name}</div>
                        {hasSubtitle && (
                            <div>
                                {choice.addition > 0
                                    ? `+ ${choice.addition} €`
                                    : "ohne Aufschlag"}
                            </div>
                        )}
                        {choice.text && <SubText>{choice.text}</SubText>}
                    </ChoiceButton>
                );
            })}
        </Container>
    );
};

export default ChoiceButtons;
